import React from 'react';
import './styles/Button.css';

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  icon: Icon,
  iconPosition = 'left',
  className = '',
  ...props
}) => {
  const baseClass = 'btn';
  const variantClass = `btn-${variant}`;
  const sizeClass = `btn-${size}`;
  const fullWidthClass = fullWidth ? 'btn-full-width' : '';
  
  const classes = `${baseClass} ${variantClass} ${sizeClass} ${fullWidthClass} ${className}`;
  
  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {Icon && iconPosition === 'left' && <Icon className="btn-icon" />}
      {loading ? <span className="btn-loading-spinner" /> : children}
      {Icon && iconPosition === 'right' && <Icon className="btn-icon" />}
    </button>
  );
};

export default Button;
